<mat-card class="summary-card">
  <div class="summary-title" style="background: #f58220;">TOP 20 TODAY</div>
  <div class="summary-content-table">
    <table class="top20-table">
      <thead>
        <tr>
          <th>SALES ITEM</th>
          <th class="text-right amount-col">$</th>
          <th class="text-right percent-col">%</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dashboardTop10Today; let i = index" [class.alt-row]="i % 2 === 1">
          <td>{{ item.sale_item }}</td>
          <td class="text-right amount-col">${{ item.amount | number:'1.2-2' }}</td>
          <td class="text-right percent-col">{{ getPercent(item.amount) | number:'1.2-2' }}%</td>
      </tbody>
    </table>
  </div>
  <div class="summary-footer-total" *ngIf="dashboardTop10Today.length">
    <div class="total-label">TOTAL</div>
    <div class="total-amount">${{ todayTop10Sum | number:'1.2-2' }}</div>
    <div class="total-percent">100.00%</div>
  </div>
</mat-card>